const {
  benhurEstimateTotals
} = require('../lib/benhur/totals');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evaluate - evaluate benhurEstimateTotalsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  return benhurEstimateTotals(values);
};
module.exports = {
  evaluate
};